// Note: BASE_SCM_SERVICE_TAG_TYPES should be sorted in lexicographical order

export const BASE_SCM_SERVICE_TAG_TYPES = [
  'AcademyProject',
  'AcademyTopic',
  'CapstoneSubmission',
  'CourseAssessmentMentee',
  'CoursePauseRequest',
  'Library',
  'MenteeModule',
  'Playlist',
  'RecordingRequest',
  'SbatGroup',
  'SuperBatch',
  'SuperBatchModule',
  'SuperBatchProject',
];
